"use client";
import { ark } from "../factory.js";
import { useFieldContext } from "./use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-error-text.tsx
var FieldErrorText = forwardRef((props, ref) => {
	const field = useFieldContext();
	const mergedProps = mergeProps(field.getErrorTextProps(), props);
	if (field?.invalid) return /* @__PURE__ */ jsx(ark.span, {
		...mergedProps,
		ref
	});
	return null;
});
FieldErrorText.displayName = "FieldErrorText";
//#endregion
export { FieldErrorText };
